<template>
  <div>
    <!-- TABELA DE banners -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Banners</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th style="width: 30px">Id</th>
                <th>Imagem</th>
                <th>Data criação</th>
                <th style="text-align: center">Ativo</th>
                <th>Leilão</th>
                <th>Lote</th>
                <th>Expira em</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(banner, index) in banners" :key="banner">
                <td data-label="Id">{{ banner.id }}</td>
                <td data-label="Criação">
                  <img
                    data-toggle="modal"
                    data-target="#image-modal"
                    @click="banner_selecionado = banner"
                    style="cursor: pointer"
                    width="90px"
                    height="50px"
                    :src="getImagePath(banner)"
                  />
                </td>
                <td data-label="Data criação">{{ formatDate(banner.created_at) }}</td>
                <td data-label="Ativo" style="text-align: center; min-width: 50px">
                  <div class="row" style="min-width: 150px">
                    <div class="col-md-6">
                      <input class="form-check-input" type="radio" value="Sim" v-model="banner.ativo" @change="atualizarBannerAtivo(banner)" />
                      <label class="form-check-label">Sim</label>
                    </div>
                    <div class="col-md-6">
                      <input class="form-check-input" type="radio" value="Não" v-model="banner.ativo" @change="atualizarBannerAtivo(banner)" />
                      <label class="form-check-label">Não</label>
                    </div>
                  </div>
                </td>
                <td data-label="Leilão" v-if="banner.leilao_id">{{ banner.leilao_id }}</td>
                <td data-label="Leilão" v-else>-</td>

                <td data-label="Leilão" v-if="banner.lote_id">{{ banner.lote_id }}</td>
                <td data-label="Leilão" v-else>-</td>

                <td data-label="Expira em">{{ getExpiraEm(banner) }}</td>

                <td>
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a :href="getUrlEdit(banner)" class="dropdown-item">
                      <i class="fa-solid fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>
                    <div class="dropdown-divider"></div>
                    <a @click="deletarBanner(banner)" class="dropdown-item">
                      <i class="fa-solid fa-trash"></i>
                      &nbsp;&nbsp; Deletar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal fade" id="image-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="background-color: #4a4949">
              <div class="modal-body">
                <img
                  style="position: relative; max-height: 1700px; max-width: 1500px; object-fit: contain"
                  :src="getImageFoto(banner_selecionado)"
                  class="product-image im"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + banners.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      logo_selecionado: "",
      filtro: "",
      paginas: [],
      banners: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      banner_selecionado: "",
    };
  },

  mounted() {
    console.log(this.banners);
    this.buscarBanners();
  },

  methods: {
    deletarBanner(banner) {
      let html = "Deseja deletar esse banner? Esta ação é irreversível.";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: banner.id,
            };

            console.log("DELETANDO banner");
            console.log(data);

            axios
              .post(`/admin/banner/delete`, data)
              .then((response) => {
                this.isLoading = false;

                if (response.data.success) {
                  this.showSuccessMessage("Documento deletado!");

                  let data = {
                    path: this.getOnlyDocumentPath(banner),
                  };

                  console.log("DELETANDO S3");
                  console.log(data);

                  axios
                    .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
                    .then((response) => {})
                    .catch((error) => {
                      console.log(error);
                      this.isLoading = false;
                      this.showErrorMessageWithButton("Ops..", error);
                    });

                  this.buscarBanners();
                } else {
                  this.showErrorMessageWithButton("Ops...", response.data.msg);
                }
              })
              .catch((error) => {
                console.log(error);
                this.showErrorMessageWithButtonAndRefresh("Ops..", "Falha na confirmação");
                this.isLoading = false;
              });
          }
        });
    },

    getOnlyDocumentPath(banner) {
      console.log("banner get path");
      console.log(banner);

      if (banner) {
        if (banner.path.includes("rochaleiloes3")) {
          return banner.path + "/" + banner.arquivo;
        } else if (banner.path.includes("rochaleiloes2")) {
          return banner.path + "/" + banner.arquivo;
        } else if (banner.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return banner.path + "/" + banner.arquivo;
        } else {
          return banner.path + "/" + banner.arquivo;
        }
      }
    },
    atualizarBannerAtivo(banner) {
      let data = {
        banner_id: banner.id,
        ativo: this.convertToTiny(banner.ativo),
      };

      console.log(data);

      axios
        .post(`/admin/banner/atualizar_ativo`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    convertToTiny(value) {
      if (value == "Não") {
        return 0;
      } else {
        return 1;
      }
    },

    getImagePath(banner) {
      if (banner.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + banner.path + "/" + banner.arquivo;
      } else if (banner.path.includes("rochaleiloes") || banner.arquivo.includes("banner_")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + banner.path + "/" + banner.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + banner.path + "/" + banner.arquivo;
      }
    },

    getImageFoto(banner) {
      if (banner) {
        if (banner.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + banner.path + "/" + banner.arquivo;
        } else if (banner.path.includes("rochaleiloes") || banner.arquivo.includes("banner_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + banner.path + "/" + banner.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + banner.path + "/" + banner.arquivo;
        }
      }
    },

    getUrlEdit(banner) {
      return "/admin/banner/" + banner.id;
    },

    show(banner) {
      this.logo_selecionado = banner;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarBanners();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarBanners();
      }
    },

    buscarBanners() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/banner/search`, data)
        .then((response) => {
          this.banners = response.data.banners;
          this.total = response.data.total;

          for (let i = 0; i < this.banners.length; i++) {
            if (this.banners[i].ativo) {
              if (this.banners[i].ativo == 1) {
                this.banners[i].ativo = "Sim";
              } else {
                this.banners[i].ativo = "Não";
              }
            } else {
              this.banners[i].ativo = "Não";
            }
          }

          console.log(this.banners);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarBanners();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    getExpiraEm(banner) {
      if (banner.leilao_id) {
        if (banner.leilao.leilao_num_pracas >= 4 && banner.leilao.leilao_4_data) {
          return moment(banner.leilao.leilao_4_data).format("DD/MM/YYYY HH:mm:ss");
        }

        if (banner.leilao.leilao_num_pracas >= 3 && banner.leilao.leilao_3_data) {
          return moment(banner.leilao.leilao_3_data).format("DD/MM/YYYY HH:mm:ss");
        }

        if (banner.leilao.leilao_num_pracas >= 2 && banner.leilao.leilao_2_data) {
          return moment(banner.leilao.leilao_2_data).format("DD/MM/YYYY HH:mm:ss");
        }

        if (banner.leilao.leilao_num_pracas >= 1 && banner.leilao.leilao_1_data) {
          return moment(banner.leilao.leilao_1_data).format("DD/MM/YYYY HH:mm:ss");
        }
      }
      return moment(banner.expires_at).format("DD/MM/YYYY HH:mm:ss");
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.im {
  width: 1000px;
}

.modal-content {
  width: 1040px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 900px;
    margin-left: -00px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 900px;
    margin-left: -180px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
